import Vue from 'vue'
import Vuex from 'vuex'
import {quanxianlie,zongquanxianlie} from '@/api/quanxian.js';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		zongquanxian:{shu:[],lie:[],id:[]},
		quanxian:{shu:[],lie:[],id:[]},
		yonghu:{},
		SAAS:0
  },
  mutations: {
	gaiquanxian(state,shu){
		state.quanxian=shu;
	},
	gaizongquanxian(state,shu){
		state.zongquanxian=shu;
		state.SAAS=shu.SAAS;
	},
	gaiyonghu(state,shu){
		state.yonghu=shu;
	}
  },
  actions: {
		huoquzongquanxian(context){
			if(!context.state.zongquanxian.id || context.state.zongquanxian.id.length==0){
				zongquanxianlie().then(shu => {
					 context.commit('gaizongquanxian',shu.shu)
				})
			}
		},
		huoququanxian(context){
			// if(!context.state.quanxian.id || context.state.quanxian.id.length==0){
				quanxianlie().then(shu => {
					 context.commit('gaiquanxian',shu.shu)
				})
			// }
		}
  }
})
